import gql from "graphql-tag";

export const WS_CONFIG_FRAGMENT = gql`
    fragment wsConfigFragment on WsConfig {
        maxOrgSearchResult
        maxPosSearchResult
        maxIndSearchResult
        jwtTokenExpiryTime
        publishRefreshInfo
        publishRefreshTime
    }
`;

export const WS_CLIENT_FRAGMENT = gql`
    fragment wsClientFragment on WsClient {
        clientName
        active
        description
    }
`;

export const GET_WS_CONFIG = gql`
    ${WS_CONFIG_FRAGMENT}
    query WsConfig {
        wsConfig {
            ...wsConfigFragment
        }
    }
`;

export const UPDATE_WS_CONFIG = gql`
    ${WS_CONFIG_FRAGMENT}
    mutation UpdateWsConfig($input: WsConfigInput!) {
        updateWsConfig(input: $input) {
            ...wsConfigFragment
        }
    }
`;

export const GET_WS_WEB_SERVICES = gql`
    query GetWsWebServices {
        wsWebServices {
            webServiceId
            code
            name
        }
    }
`;

export const GET_WS_CLIENTS = gql`
    ${WS_CLIENT_FRAGMENT}
    query GetWsClients {
        wsClients {
            clientId
            ...wsClientFragment
        }
    }
`;

export const UPDATE_WS_CLIENT = gql`
    ${WS_CLIENT_FRAGMENT}
    mutation UpdateWsClient($clientId: ID!, $input: WsClientInput!) {
        updateWsClient(clientId: $clientId, input: $input) {
            ...wsClientFragment
        }
    }
`;

export const CREATE_WS_CLIENT = gql`
    ${WS_CLIENT_FRAGMENT}
    mutation CreateWsClient($input: WsClientInput!) {
        createWsClient(input: $input) {
            ...wsClientFragment
        }
    }
`;
